import React from 'react';
import { PropTypes } from 'prop-types';
// styles
import styled from 'styled-components';
// state
import { useSoFormStepsApi, useSoFormStepsState } from '../../SoForm.context';
// components
import SoFormButton from '../../components/other/SoFormButton';
import SoFormContainer from '../../components/layout/SoFormContainer';
import { ChevronRightIcon } from 'refactored/ui/icons';
import LoadSpinner from 'components/LoadSpinner';
import { useTranslation } from 'react-i18next';

const SoFormStepComplementsFooter = ({ className }) => {
  const { t } = useTranslation('Catalog');

  const stepsApi = useSoFormStepsApi();
  const stepsState = useSoFormStepsState();

  const isLoading = stepsState.complements.isLoading;

  return (
    <div className={className}>
      <SoFormContainer>
        <SoFormButton inverse={true} onClick={stepsApi.onComplementsGoBack}>
          {t('complements.go_to_previus_step')}
        </SoFormButton>
        <SoFormButton
          disabled={isLoading}
          onClick={stepsApi.onComplementsSubmit}
        >
          {!isLoading && (
            <>
              {t('complements.review_and_confirm')} <ChevronRightIcon />
            </>
          )}
          {isLoading && <LoadSpinner />}
        </SoFormButton>
      </SoFormContainer>
    </div>
  );
};

SoFormStepComplementsFooter.propTypes = {
  className: PropTypes.string,
};

export default styled(SoFormStepComplementsFooter)`
  width: 100%;
  padding: 0px;
  padding-bottom: 16px;
  padding-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: center;
  & > ${SoFormContainer} {
    gap: 10px;
    ${SoFormButton} {
      max-width: 50%;
    }
  }
`;
